'use strict!'

// returns new {} with lowercase keys
export const lowerCaseObject = (src) => {
    const obj = {}
    Object.keys(src).forEach(key => {
        obj[key.toLowerCase()] = src[key]
    })
    return obj
}

export const mockPromise = (time, resolvePromise) =>
    new Promise((resolve, reject) => {
        const interval = setInterval(() => {
        clearInterval(interval)
        resolvePromise ? resolve() : reject()
        }, time)
    })

export const preloadImages = async (imageURLs = [], forceTime = null) => {
    const promises = imageURLs.map(url => new Promise((resolve, reject) => {
        const img = new Image()
        img.onerror = reject
        img.onload = resolve
        img.src = url
    }))

    const promisesAll = Promise.all(promises)

    return isNaN(forceTime)
    ? promisesAll
    : Promise.race([promisesAll, mockPromise(forceTime, true)])
}

// Takes [{}] and converts to new [{value: valueKey, label: labelKey}]
export const convertToOptions = (list = [], valueKey = '', labelKey = '') => 
	list.map(item => ({
		value: item[valueKey],
		label: item[labelKey]
	})
)

// Takes object and returns a cloned object where the value of a key is val and keys in ignore are ignored
export const getResetObject = (obj = {}, val = null, ignore = []) => {
	const clone = JSON.parse(JSON.stringify(obj))
	Object.keys(clone).forEach(k => {
		if (!ignore.includes(k)) clone[k] = val
	})
	return clone
}